import React, { useState, useEffect, useReducer } from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select
const GenerateCompanyFunctional = (state, action) => {
  switch (action.type) {
    case 'Generate_key':
      return state.map((parent, idxParent) => {
        const Key_parent = `0-${idxParent}`
        const state_parent = {
          ...parent,
          key: Key_parent,
          disabled: true,
          children: null,
        }
        return state_parent
      })
    default:
      return state
  }
}
const Company = (props) => {
  const {
    setChoiceCompany,
    setChoiceOperation,
    setChoiceSubOperation,
    masterData,
    choiceCompany,
    choiceOperation,
    choiceSubOperation,
    setAccountOptions,
    form,
    setType,
    RebaseCutterFunctionally,
    setChoiceProjectGroup,
    setChoiceProjectCategory,
    setChoiceImpactType,
    defaultCompanyName,
  } = props
  const [GenerateCompany, dispatch] = useReducer(GenerateCompanyFunctional, masterData)
  const [companyAll, setCompanyAll] = useState(GenerateCompany)
  const [choice, setChoice] = useState(choiceCompany)
  // console.log("choice", choice)
  // console.log("companyAll", companyAll)
  // console.log("masterdata", masterData)
  let url_page = window.location.pathname
  useEffect(() => {
    if (masterData) {
      dispatch({ type: 'Generate_key', payload: masterData })
    }
  }, [masterData])
  useEffect(() => {
    setChoiceCompany(choice)
  }, [])

  const handleSelectCompany = (val) => {
    setAccountOptions([])
    setChoiceCompany(val)
    setChoice(val)

    RebaseCutterFunctionally('from company', val, choiceOperation, choiceSubOperation)
    if (val.length === 0) {
      ;(setChoiceOperation([]),
        setChoiceSubOperation([]),
        setChoiceProjectGroup([]),
        setChoiceProjectCategory([]),
        setChoiceImpactType([]),
        form.setFieldsValue({ radio_choice: 1, user_select: [] }))
      setType(1)
    }
  }

  const defaultCompanyNames = String(defaultCompanyName || '')
    .split(',')
    .map((item) => item.trim())
    .filter((item) => item)

  const fallbackCompanyOptions = (choice || []).reduce((result, companyId, index) => {
    const hasActiveOption = (companyAll || []).some(
      (company) => String(company.company_id) === String(companyId),
    )

    if (!hasActiveOption) {
      const companyName = defaultCompanyNames[index] || '-'
      result.push({
        company_id: companyId,
        title: companyName,
      })
    }

    return result
  }, [])

  const companyOptions = [...companyAll, ...fallbackCompanyOptions]

  return !url_page.includes('/management/powerbi') ? (
    <Select
      mode="multiple"
      size="large"
      style={{ width: '100%' }}
      defaultValue={choice}
      placeholder="Select Business"
      onChange={handleSelectCompany}
      maxTagCount={0}
      maxTagPlaceholder={(event) => {
        return event[0].label
      }}
      tagRender={(event) => {
        const { label } = event
        if (choice?.length > 1) {
          return (
            <Tag
              style={{
                display: 'flex',
                fontSize: 12,
                borderRadius: '16px',
                background: 'rgba(7, 78, 159, 0.1)',
                height: '32px',
                alignItems: 'center',
                color: '#074E9F',
              }}
            >
              {'Multi select business'}
            </Tag>
          )
        }
        return (
          <Tag
            style={{
              display: 'flex',
              fontSize: 12,
              borderRadius: '16px',
              background: 'rgba(7, 78, 159, 0.1)',
              height: '32px',
              alignItems: 'center',
              color: '#074E9F',
            }}
          >
            {label}
          </Tag>
        )
      }}
    >
      {companyOptions.map((item) => (
        <Option value={item.company_id} name={item.title}>
          {item.title}
        </Option>
      ))}
    </Select>
  ) : (
    <Select
      mode="multiple"
      size="large"
      style={{ width: '100%' }}
      defaultValue={choice}
      placeholder="Select Business"
      onChange={handleSelectCompany}
    >
      {companyOptions.map((item) => (
        <Option value={item.company_id} name={item.title}>
          {item.title}
        </Option>
      ))}
    </Select>
  )
}
export default Company
